<template>
  <div class="per-box">
    <ul class="info-list">
      <li class="head-img" @click="getData">
        <label>头像</label>
        <div class="user-img" @click="upload">
          <img :src="perData.pic" id="img" alt />
        </div>
        <input type="file" id="input" @change="getFile($event)" />
      </li>
      <li>
        <label>账户名</label>
        <input type="text" v-model="perData.nickName" />
      </li>
      <li>
        <label>性别</label>
        <span :class="{'sex':true, 'active':perData.sex==1}" @click="setSex(1)">
          <i class="iconfont icon-danxuananniu"></i>男
        </span>
        <span :class="{'sex':true, 'active':perData.sex==2}" @click="setSex(2)">
          <i class="iconfont icon-danxuananniu"></i>女
        </span>
      </li>
      <li>
        <label>生日</label>
        <input type="date" placeholder="请填写生日 格式：xxxx/xx/xx" v-model="perData.shengRi" />
      </li>
      <li>
        <label style="margin-right:26px;">个人简介</label>
        <textarea placeholder="请填写个人简介" class="intro" v-model="perData.des" v-on:input="getLength"></textarea>
        <p class="static">
          <span style="margin:0px;" v-text="desLen">0</span> / 30
        </p>
      </li>
      <div class="usercenter-select">
        <div class="select">
          <div class="select-info">职业</div>
          <input class="select-main" placeholder="请选择职业" v-model="perData.zhiYe" />
        </div>
        <!-- <div class="option" v-show="showPost">
           <span v-for="(items,index) in cont" @click="cho(items)" :key="index">{{items}}</span>
        </div>-->
      </div>
      <div class="usercenter-select">
        <div class="select">
          <div class="select-info">行业</div>
          <input class="select-main" placeholder="请选择行业" v-model="perData.hangYe" />
        </div>
        <!-- <div class="option" v-show="showIdoe">
          <span v-for="(item,index) in content" @click="choice(item)" :key="index">{{item}}</span>
        </div>-->
      </div>
    </ul>
    <div class="save" @click="changeData">保存</div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import { createHash } from "crypto";
export default {
  //   name: "App",
  data() {
    return {
      perData: {
        pic: "",
        nickName: "",
        sex: 1,
        shengRi: "",
        des: "",
        zhiYe: "",
        hangYe: "",
        pic: "../../assets/img/user.png"
      },
      desLen: 0,
      showPost: false,
      showIdoe: false
    };
  },
  mounted() {
    this.setSex(this.perData.sex);
    this.getData();
  },
  methods: {
    upload() {
      $("#input").click();
    },
    getFile(e) {
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "https://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res+ "上传头像");
        this.perData.pic = res.data.url;
        // alert(res.data.url);
      });
    },
    setSex(s) {
      //修改性别
      this.perData.sex = s;
    },
    
    getData() {
      //获取用户信息
      this.$http
        .get("/api/user/013-getUserInfoById", {
          params: {
            id: this.$store.state.userInfo.id
          }
        })
        .then(res => {
          // console.log(res, "获取用户信息");
          if (res.status == 200 && res.data.code == 0) {
            this.perData = res.data.rows[0];
            this.getLength();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeData() {
      //修改用户信息
      this.$http
        .get("/api/user/008-editCusUserInfo", {
          params: {
            nickName: this.perData.nickName,
            pic: this.perData.pic,
            sex: this.perData.sex,
            shengRi: this.perData.shengRi,
            des: this.perData.des,
            zhiYe: this.perData.zhiYe,
            hangYe: this.perData.hangYe,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(JSON.stringify(res) + "保存信息");
          if (res.status == 200 && res.data.code == 0) {
            this.perData = res.data.rows[0];
            this.$message("保存成功");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getLength() {
      //获取textarea 长度
      this.desLen = this.perData.des.length;
      if (this.desLen > 30) {
        alert("字数过长");
        return false;
        this.desLen = this.desLen.substr(0, 30);
      }
    }
  }
};
</script>
<style scoped>
.per-info .info-list li span.sex {
  float: left;
}
.per-info .info-list li textarea {
  padding: 8px 7px;
}
.usercenter-select .select .select-main {
  margin-left: 3px;
}
#input {
  display: none;
  width: 200px;
  float: left;
  margin: 25px 0px 0px 20px;
}
</style>